module.exports = __webpack_public_path__ + "static/media/社区团购_17.f55a1665.png";